<template>
  <div>
    <div class="timeWrap">
      <div class="airspaceName" :title="data.name">{{data.name}}</div>
      <div class="time-axis">
        <!-- 时间轴刻度 -->
        <div class="time-scale">
          <div
            v-for="(hour, index) in 24"
            :key="index"
            class="hour"
            :style="{ width: (100 / 24) + '%' }"
          >
            {{ index }}
          </div>
        </div>
        <!-- 时间轴进度条 -->
        <div class="time-progress">
          <div
            v-for="(timeRange, index) in data.timeAndHeightList"
            :key="index"
            class="time-range"
            :style="{
          left: (getTimeLeft(timeRange.startTime)) + '%',
          width: (getTimeWidth(timeRange.startTime, timeRange.endTime)) + '%',
          backgroundColor: 'rgba(173, 216, 230, 0.5)'

        }"
            @click="showPopup(timeRange)"
          >
            {{timeRange.height}}
          </div>
        </div>
        <!-- 弹窗 -->
        <el-dialog
          :visible.sync="isPopupVisible"
          width="20%"
          :modal="false"
          :before-close="close">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="formRef"
              label-width="80px"
              label-position="left"
              class="demo-ruleForm"
            >
              <el-form-item class="time" label="开始时间" prop="date1">
                <el-date-picker
                  v-model="ruleForm.date1"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择时间"
                  :picker-options="disabledStartDate"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item class="time" label="结束时间" prop="date2">
                <el-date-picker
                  v-model="ruleForm.date2"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择时间"
                  :picker-options="disabledEndDate"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item class="time" label="高度" prop="height">
                <el-input  v-model="ruleForm.height"  placeholder="请输入高度"></el-input>
              </el-form-item>
            </el-form>

          <span slot="footer" class="dialog-footer">
              <el-button class="delete" @click="handelDel">删 除</el-button>
              <el-button class="submit" type="primary" @click="submitForm">提 交</el-button>
            </span>
        </el-dialog>

        <div v-if="isPopupVisible" class="popup">
          <span class="close" @click="close">x</span>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    //父组件传递的数据
    data: {
      type: Object,
      default: {}
    },
    update:{
      type: Function,
      default: null
    }
  },
  data() {
    const validateHeight = (rule, value, callback) => {
      if (isNaN(value) || value <= 0) {
        callback(new Error('高度必须为大于 0 的数字'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        date1: [
          {required: true, message: "请选择开始时间", trigger: "change"},
        ],
        date2: [
          {required: true, message: "请选结束时间", trigger: "change"},
        ],
        height: [
          {required: true, message: "请输入高度", trigger: "blur"},
          { validator: validateHeight, trigger: 'blur' }
        ],
      },
      ruleForm:{
        date1:null,
        date2:null,
        height:null
      },
      timeRanges: [], // 后端返回的时间范围
      isPopupVisible: false, // 弹窗是否可见
      selectedTimeRange: {} // 当前选中的时间范围
    };
  },
  computed:{
    disabledStartDate() {
      //选择的日期
      let curDate = this.$moment(this.ruleForm.date1).format("YYYY-MM-DD")
      if (this.ruleForm.date2) {
        //最大日期
        let maxDate = this.$moment(this.ruleForm.date2).format("YYYY-MM-DD")
        // 如果选择的日期为最大日期，则设置为最大日期的时分秒
        let str = ""
        if (curDate == maxDate) {
          str = this.$moment(this.ruleForm.date2).format("HH:mm:ss")
        } else {
          str = "23:59:59"
        }
        return {
          disabledDate: (time) => {
            return time.getTime() > this.ruleForm.date2
          },
          selectableRange: "00:00:00 - " + str,
        }
      } else {
        return {
          disabledDate: () => {
            return false
          },
        }
      }
    },
    disabledEndDate() {
      //选择的日期
      let curDate = this.$moment(this.ruleForm.date2).format("YYYY-MM-DD")

      if (this.ruleForm.date1) {
        //最小日期
        let minDate = this.$moment(this.ruleForm.date1).format("YYYY-MM-DD")
        //前推一天，防止当天日期无法选择
        let preTime = this.ruleForm.date1 - 24 * 3600000
        // 如果选择的日期为最小日期，则设置为最小日期的时分秒
        let str = ""
        if (curDate == minDate) {
          str = this.$moment(this.ruleForm.date1).format("HH:mm:ss")
        } else {
          str = "00:00:00"
        }
        return {
          disabledDate: (time) => {
            return time.getTime() < preTime
          },
          selectableRange: str + " - 23:59:59",
        }
      } else {
        return {
          disabledDate: () => {
            return false
          },
        }
      }
    },
  },
  mounted() {

  },
  methods: {
    changeData(date) {
      var date = new Date(date);
      // 获取年、月、日、时、分、秒
      var year = date.getFullYear();
      var month = date.getMonth() + 1; // getMonth() 返回0-11，需要加1
      var day = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      // 为月、日、时、分、秒添加前导0，如果它们小于10
      month = (month < 10 ? "0" : "") + month;
      day = (day < 10 ? "0" : "") + day;
      hours = (hours < 10 ? "0" : "") + hours;
      minutes = (minutes < 10 ? "0" : "") + minutes;
      seconds = (seconds < 10 ? "0" : "") + seconds;
      // 构建并返回格式化的日期时间字符串
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    close(){
      this.isPopupVisible = false;
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let data = {
            airspaceId:this.ruleForm.airspaceId,
            index:this.ruleForm.index,
            startTime:this.ruleForm.date1,
            endTime:this.ruleForm.date2,
            height:this.ruleForm.height,
          }
          this.postJsonRequest("/uav-task-server/airspace/changeAirspaceUseGraph",data).then(res => {
            const data = res.data
            if (data.code === 0) {
              this.$message({
                message: "修改成功",
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {},
              });
              this.$emit("update",'update')
              this.isPopupVisible = false;
            }else {
              this.$message.error({
                message: "修改失败",
                duration: 1000,
                customClass: "message-warn-s",
                iconClass: "el-icon-warn-tip",
                offset: 470,
                onClose: function () {
                }
              });
            }
          })
        } else {
          return false;
        }
      });
    },
    // 将时间字符串转换为分钟数
    timeToMinutes(time) {
      const [hours, minutes] = time.split(':').map(Number);
      return hours * 60 + minutes;
    },
    // 计算时间范围的左偏移量
    getTimeLeft(start) {
      const totalMinutes = 24 * 60;
      const startMinutes = this.timeToMinutes(start.split(' ')[1]);
      return (startMinutes / totalMinutes) * 100;
    },
    // 计算时间范围的宽度
    getTimeWidth(start, end) {
      const totalMinutes = 24 * 60;
      const startMinutes = this.timeToMinutes(start.split(' ')[1]);
      const endMinutes = this.timeToMinutes(end.split(' ')[1]);
      return ((endMinutes - startMinutes) / totalMinutes) * 100;
    },
    // 显示弹窗
    showPopup(timeRange) {
      this.ruleForm.date1 = timeRange.startTime
      this.ruleForm.date2 = timeRange.endTime
      this.ruleForm.height = timeRange.height
      this.ruleForm.index = timeRange.index
      this.ruleForm.airspaceId = timeRange.airspaceId
      this.selectedTimeRange = timeRange;
      this.isPopupVisible = true;
    },
    // 删除
    handelDel() {
      this.postJsonRequest("/uav-task-server/airspace/deleteTimeAndHeight",this.ruleForm).then(res => {
        const data = res.data
        if (data.code === 0) {
          this.$message({
                    message: "删除成功",
                    duration: 1000,
                    customClass: "message-s",
                    iconClass: "el-icon-ok-tip",
                    offset: 470,
                    onClose: function () {},
                  });
          this.$emit("update",'update')
          this.isPopupVisible = false;
        }else {
          this.$message.error({
            message: "删除失败",
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    }
  }
};
</script>

<style scoped>
>>>.el-dialog{
  background: url("../../../assets/img/common/kong_yu_xie_tong_pop_bg.png");
}
>>>.el-form-item__label{
  color:#fff !important;
}
>>>.el-dialog__footer{
  text-align: center;
  padding-bottom: 46px;
}
>>>.el-dialog__body{
  padding:30px 20px 0 20px;
}
>>>.el-button{

  width:88px;
  height: 42px;
  font-size: 17px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #ebebeb;
}
 .delete{
  background: url("../../../assets/img/common/cancel.png") !important;
}
.submit{
  background: url("../../../assets/img/common/cancel_click.png") !important;
  margin-left: 80px;
}
.airspaceName{
  color: #FFFFFF;
  overflow: hidden;
  white-space: nowrap; /* 文本不换行 */
  text-overflow: ellipsis; /* 超出部分用省略号表示 */
  width: 105px; /* 需要设置一个固定宽度 */

}
.timeWrap{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.time-axis {
  position: relative;
  height: 50px;
  border: 1px solid #ccc;
  margin: 20px;
}

.time-scale {
  width: 732px;
  display: flex;
  height: 100%;
}

.hour {
  color: #fff;
  text-align: center;
  line-height: 50px;
  border-right: 1px solid #ccc;
}

.time-progress {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.time-range {
  cursor: pointer;
  position: absolute;
  top: 0;
  height: 100%;
  color: #00aeff;
}

.popup {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}
>>> .el-form .el-form-item__label{
  color: black;
}
.close{
  position: fixed;
  top: 2px;
  cursor: pointer;
  right: 2px;
  z-index: 1000;
}
.el-date-editor{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/time-axis/timeAxis.vue